import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";

const badgeVariants = cva(
    "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors",
    {
        variants: {
            variant: {
                default: "bg-burgundy/30 text-burgundy",
                secondary: "bg-gray-100 text-gray-800",
                outline: "border border-burgundy/30 text-burgundy",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
    VariantProps<typeof badgeVariants>;

const Badge = ({ className, variant, ...props }: BadgeProps) => {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    );
};

export { Badge, badgeVariants };
